import { CHECKOUT_URL, PRODUCT } from "../config";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const fbq = (...args) => {
  if (window.fbq) window.fbq(...args);
};

const gtag = (...args) => {
  if (window.gtag) window.gtag(...args);
};

const newEventId = () =>
  window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
};

const sendCAPI = (eventName, eventId, customData) => {
  const payload = {
    event_name: eventName,
    event_id: eventId,
    event_source_url: window.location.href,
    fbp: getCookie("_fbp"),
    fbc: getCookie("_fbc"),
    custom_data: customData || null,
  };
  fetch(`${API_URL}/api/meta/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
};

let pageViewSent = false;
export const trackPageView = () => {
  if (pageViewSent) return;
  pageViewSent = true;
  const eventId = newEventId();
  fbq("track", "PageView", {}, { eventID: eventId });
  sendCAPI("PageView", eventId);
};

let viewContentSent = false;
export const trackViewContent = (opts = {}) => {
  if (viewContentSent) return;
  viewContentSent = true;
  const eventId = newEventId();
  const customData = {
    content_name: opts.name || PRODUCT.name,
    content_category: opts.category || "AI Subscription",
    value: opts.value ?? PRODUCT.value,
    currency: "IDR",
  };
  fbq("track", "ViewContent", customData, { eventID: eventId });
  sendCAPI("ViewContent", eventId, customData);
  gtag("event", "view_item", {
    currency: "IDR",
    value: customData.value,
    items: [{ item_name: customData.content_name, price: customData.value }],
  });
};

export const goToCheckout = (source, opts = {}) => {
  const url = opts.url || CHECKOUT_URL;
  const name = opts.name || PRODUCT.name;
  const value = opts.value ?? PRODUCT.value;
  const eventId = newEventId();
  const customData = { content_name: name, value, currency: "IDR" };
  fbq("trackCustom", "ClickCTA", { source, content_name: name });
  fbq("track", "InitiateCheckout", customData, { eventID: eventId });
  sendCAPI("InitiateCheckout", eventId, customData);
  gtag("event", "begin_checkout", {
    currency: "IDR",
    value,
    items: [{ item_name: name, price: value }],
  });
  setTimeout(() => {
    window.location.href = url;
  }, 150);
};
